/* eslint-disable prettier/prettier */
import css from 'styled-jsx/css';

export const LegalConditionsModalCss = css`
  .legal-conditions-modal {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    max-width: 460px;
    height: 100vh;
    background-color: var(--color-gp--white);
    .modal__header {
      padding: 2rem 1rem;
      background-color: var(--color-gp--blue);
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    :global(.modal__close) {
      padding: 0.625rem;
      cursor: pointer;
    }
    .modal__content {
      overflow-y: auto;
      padding: 2rem;
      text-align: justify;
    }
  }
`;
